import React from 'react'
import './index.less'
// import {getGmtNum} from "../../../../request/CyHomepage";
// import useInterval from "../../../../packages/hooks/useInterval";
import {CountUp} from "countup.js";


const clsPrefix = 'c-our-comment'
const CommentContainer: React.FC<{}> = () => {
    // const [ gmtNum, setGmtNum] = useState<number>(1)
    // const [ gmtDotOneNum, setGmtDotOneNum] = useState<number>(0)
    // const [ gmtDotTwoNum, setGmtDotTwoNum] = useState<number>(0)
    // const [ gmtDotThreeNum, setGmtDotThreeNum] = useState<number>(0)
    // const [ gmtDotFourNum, setGmtDotFourNum] = useState<number>(0)

    function countUp() {
        const options = {
            duration: 1,
            useEasing: false,
        }
        const webSiteCountUp = new CountUp('webSiteId', 300, options);
        const usersNumCountUp = new CountUp('usersNumId', 3, options);
        const copNumCountUp = new CountUp('copNumId', 7, options);
        const gmtNumCountUp = new CountUp('gmtNumId', 17, options);
        if (!webSiteCountUp.error) {
            webSiteCountUp.start();
            usersNumCountUp.start();
            copNumCountUp.start();
            gmtNumCountUp.start();
        } else {
            console.error(webSiteCountUp.error);
        }
    }

    window.onload = function () {
        countUp()
    }

    // useInterval( () => {
    //         gmtNumGet()
    // }, 1500)

    // function gmtNumGet () {
    //     getGmtNum(gmtNum, new Date().getTime()).then(res => {
    //         if (res && res.code == 200) {
    //             setGmtNum(res.data)
    //             let resStr = res.data.toString()
    //             setGmtDotOneNum(resStr.substring(0, 1))
    //             setGmtDotTwoNum(resStr.substring(1, 4))
    //             setGmtDotThreeNum(resStr.substring(4, 7))
    //             setGmtDotFourNum(resStr.substring(7, 10))
    //
    //             return res.data
    //         }
    //     }).catch((err) => {
    //         console.log(err, 'err')
    //     })
    // }

    return (
        <div className={clsPrefix}>
            <div className={`${clsPrefix}-container`}>
                <div className={`${clsPrefix}-container__rowOne`}>
                    <div className={`${clsPrefix}-container__rowOne__theme1`}>
                        <div className={`${clsPrefix}-container__rowOne__content`}>
                            <div className={`${clsPrefix}__commentNum`} >
                                <div id = "webSiteId"></div>
                                <span className={`${clsPrefix}__commentNum__symbol`}>+</span>
                                <span className={`${clsPrefix}__commentNum__unit`}>万</span>
                            </div>
                            <span className={`${clsPrefix}__title`}>已安装畅言的网站</span>
                        </div>
                    </div>
                    <div className={`${clsPrefix}-container__rowOne__theme2`}>
                        <div className={`${clsPrefix}-container__rowOne__content`}>
                            <div className={`${clsPrefix}__commentNum`}>
                                {/*{usersNum}*/}
                                <div id = "usersNumId"></div>
                                <span className={`${clsPrefix}__commentNum__symbol`}>+</span>
                                <span className={`${clsPrefix}__commentNum__unit`}>亿</span>
                            </div>
                            <span className={`${clsPrefix}__title`}>累计用户数</span>
                        </div>
                    </div>
                </div>

                <div className={`${clsPrefix}-container__rowTwo`}>
                    <div className={`${clsPrefix}-container__rowTwo__theme1`}>
                        <div className={`${clsPrefix}-container__rowTwo__content`}>
                            <div className={`${clsPrefix}__commentNum`}>
                                {/*{copNum}*/}
                                <div id = "copNumId"></div>
                                <span className={`${clsPrefix}__commentNum__symbol`}>+</span>
                                <span className={`${clsPrefix}__commentNum__unit`}>万</span>
                            </div>
                            <span className={`${clsPrefix}__title`}>商务合作数</span>
                        </div>
                    </div>
                    <div className={`${clsPrefix}-container__rowTwo__theme2`}>
                        <div className={`${clsPrefix}-container__rowTwo__content`}>
                            <div className={`${clsPrefix}__commentNum`}>
                                {/*{gmtDotOneNum},{gmtDotTwoNum},{gmtDotThreeNum},{gmtDotFourNum}*/}
                                <div id = "gmtNumId"></div>
                                <span className={`${clsPrefix}__commentNum__symbol`}>+</span>
                                <span className={`${clsPrefix}__commentNum__unit`}>亿</span>
                            </div>
                            <span className={`${clsPrefix}__title`}>累计评论数</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export { CommentContainer }
